module.exports = __webpack_public_path__ + "img/t.2698ef0e.png";